import { render, staticRenderFns } from "./DriversPeriodsAvailableOverview.vue?vue&type=template&id=6028f6ba&"
import script from "./DriversPeriodsAvailableOverview.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodsAvailableOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports